<template>
    <div id="new_customer">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="contents">
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <div class="ui form" v-else>
                <div class="ui horizontal divider"><h3><i class="user icon"></i>
                    <!-- 基本資料 -->
                    {{ $t('ui.pages.customers.basic_information') }}
                </h3></div>
                <div class="fields">
                    <div class="eight wide required field">
                        <label>{{ $t('models.attributes.customers.username') }}</label>
                        <input type="text" name="username" v-model="customer.username">
                    </div>
                    <div class="eight wide required field computer column">
                        <label>{{ $t('models.attributes.customers.company_name') }}</label>
                        <input type="text" name="company_name" v-model="customer.company_name">
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide field computer column">
                        <label :data-tooltip="old_password">{{ $t('models.attributes.customers.password') }}</label>
                        <input type="password" name="password" v-model="customer.password">
                    </div>
                    <div class="eight wide field computer column">
                        <label>{{ $t('models.attributes.customers.password_confirmation') }}</label>
                        <input type="password" autocomplete="off" name="password_confirmation" v-model="customer.password_confirmation">
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide field computer column">
                        <label>{{ $t('models.attributes.customers.company_short_name') }}</label>
                        <input type="text" name="company_short_name" v-model="customer.company_short_name">
                    </div>
                    <div class="eight wide field computer column">
                        <label>{{ $t('models.attributes.customers.company_en_name') }}</label>
                        <input type="text" name="company_en_name" v-model="customer.company_en_name">
                    </div>
                </div>
                <div class="fields">
                    <div class="six wide field">
                        <label>{{ $t('models.attributes.customers.email') }}</label>
                        <input type="text" name="email" v-model="customer.email">
                    </div>
                    <div class="five wide field computer column">
                        <label>{{ $t('models.attributes.customers.phone') }}</label>
                        <input type="text" name="phone" v-model="customer.phone">
                    </div>
                    <div class="five wide field computer column">
                        <label>{{ $t('models.attributes.customers.email') }}</label>
                        <input type="text" name="fax" v-model="customer.fax">
                    </div>
                </div>

                <br>
                <div class="ui horizontal divider"><h3><i class="user icon"></i>
                    <!-- 常用寄件人資訊 -->
                    {{ $t('ui.pages.customers.common_sender_information') }}
                </h3></div>
                <br>
                <div class="fields">
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_company_name') }}</label>
                        <input type="text" name="default_sender_name" v-model="customer.default_sender_company_name">
                    </div>
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_name') }}</label>
                        <input type="text" name="default_sender_name" v-model="customer.default_sender_name">
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_address') }}</label>
                        <input type="text" name="default_sender_address" v-model="customer.default_sender_address">
                    </div>
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_phone') }}</label>
                        <input type="text" name="default_sender_phone" v-model="customer.default_sender_phone">
                    </div>
                </div>
                <div class="fields">
                    <div class="six wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_email') }}</label>
                        <input type="text" name="default_sender_email" v-model="customer.default_sender_email">
                    </div>
                    <div class="five wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_fax') }}</label>
                        <input type="text" name="default_sender_fax" v-model="customer.default_sender_fax">
                    </div>
                    <div class="five wide field">
                        <label>{{ $t('models.attributes.customers.default_sender_url') }}</label>
                        <input type="text" name="default_sender_url" v-model="customer.default_sender_url">
                    </div>
                </div>
                <br>
                <div class="ui horizontal divider"><h3><i class="user icon"></i>
                    <!-- 常用收件人資訊 -->
                    {{ $t('ui.pages.customers.common_consignee_information') }}
                </h3></div>
                <br>
                <div class="fields">
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_consignee_company_name') }}</label>
                        <input type="text" name="default_sender_name" v-model="customer.default_consignee_company_name">
                    </div>
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_consignee_name') }}</label>
                        <input type="text" name="default_consignee_name" v-model="customer.default_consignee_name">
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_consignee_address') }}</label>
                        <input type="text" name="default_consignee_address" v-model="customer.default_consignee_address">
                    </div>
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_consignee_phone') }}</label>
                        <input type="text" name="default_consignee_phone" v-model="customer.default_consignee_phone">
                    </div>
                </div>
                <div class="fields">
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_consignee_email') }}</label>
                        <input type="text" name="default_consignee_email" v-model="customer.default_consignee_email">
                    </div>
                    <div class="eight wide field">
                        <label>{{ $t('models.attributes.customers.default_consignee_fax') }}</label>
                        <input type="text" name="default_consignee_fax" v-model="customer.default_consignee_fax">
                    </div>
                </div>
                <div class="eight wide field">
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" tabindex="0" class="hidden" v-model="customer.can_use_associated_partitions">
                        <label>
                            <!-- 是否開放使用「我的號碼區間」 -->
                            {{ $t('ui.pages.customers.is_open_use_associated_partition') }}
                        </label>
                    </div>
                </div>
                <div class="eight wide field">
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" tabindex="0" class="hidden" v-model="customer.can_use_provider_partitions">
                        <label>
                            <!-- 是否開放使用「自用號碼區間」 -->
                            {{ $t('ui.pages.customers.is_open_use_use_yourself_partition') }}
                        </label>
                    </div>
                </div>

                <div class="ui divider"></div>
                <div class="ui basic positive button" @click="create_customer">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'provider_customers'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "NewCustomer",
    data() {
        return {
            is_loading: false,
            old_password: "",
            customer: {
                username: null,
                password: null,
                password_confirmation: null,
                company_name: null,
                company_short_name: null,
                company_en_name: null,
                email: null,
                phone: null,
                fax: null,
            },
            errors: [],
        }
    },
    mounted() {
        this.form_validation()
    },
    computed: {
    },
    methods: {
        create_customer() {
            var customer = _.clone(this.customer)
            this.errors = []

            if (customer.username && customer.password && customer.password_confirmation && customer.company_name) {
                if (customer.password != customer.password_confirmation) {
                    // 密碼與確認密碼不相符
                    var error_content = this.$t('ui.pages.customers.helps.the_password_does_not_match_the_confirmation_password')
                    this.errors.push(error_content)
                    this.$noty.error(error_content)
                } else {
                    var url = this.$store.state.provider.routes.api_v1_provider_customers_create

                    this.is_loading = true
                    axios.post(url, customer, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                        .then(response => {
                            if (response.data.status == "success") {
                                this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "customers")
                                // this.$noty.success('建立 客戶 成功')
                                this.$noty.success(
                                    this.$t('ui.notifications.success.create__name', {
                                        name: this.$t('models.customers')
                                    })
                                )
                                this.$router.push({name: 'provider_customer', params: {customer_identity: response.data.customer.identity}})
                            } else {
                                console.log(response.data)
                                this.errors = response.data.errors
                                // this.$noty.error('無法建立customer')
                                this.$noty.error(
                                    this.$t('ui.notifications.error.update__name', {
                                        name: this.$t('models.customers'),
                                        reason: ": " + response.data.errors
                                    })
                                )
                            }
                        })
                        .catch(error => {
                            console.log(error.response)
                        })
                        .then(() => {
                            this.is_loading = false
                        })

                }
            } else {
                // 請檢查必填欄位(*標記)是否確實填寫
                this.errors.push(
                    this.$t('ui.notifications.error.please_check_to_write_in_the_required_fields_mark')
                )
            }
        },
        form_validation() {
            $('.ui.form').form({
                on: 'blur',
                fields: {
                    username: "empty",
                    password: "empty",
                    password_confirmation: "empty",
                    company_name: "empty",
                }
            })
        }
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped lang="scss">
</style>
